import { useContext, useState } from 'react';
import { useCallback } from 'react';
import {
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
  WritableStoreDataSchema,
} from '../client-sdk/api';
import { HimmaContext } from '../Context/HimmaContext';
export const useStoreApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllStores = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        console.log(      
         
          query,
          'query in getAllStores');

        const response = await api.getAllStoresForAdmin(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.statusFilter,
          query.addedByFilter,
          query.merchantId,
          query.storeType,
          query.search,
          query.storeId,
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const createStores = useCallback(
    async (subAdminData: WritableStoreDataSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addStore(subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleStoreStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleStoreStatus(toggleStoreStatusRequest);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteStore = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteStore: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteStores(deleteStore);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editStore = useCallback(
    async (localStorageStoreId: string, subAdminData: WritableStoreDataSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editStore(localStorageStoreId, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllStores,
    createStores,
    getToggleStatus,
    deleteStore,
    editStore,
    loading,
    error,
  };
};
